import { useState } from "react";

const DEFAULT_DIRECTIONS = [
  { value: "outgoing", label: "Uitgaand" },
  { value: "incoming", label: "Inkomend" },
  { value: "internal_note", label: "Interne notitie" },
];

export default function CommunicationMessageComposer({
  title,
  includeSubject = false,
  subjectPlaceholder = "Onderwerp",
  submitLabel = "Opslaan",
  disabled = false,
  onSubmit,
  initialDirection = "outgoing",
}) {
  const [subject, setSubject] = useState("");
  const [direction, setDirection] = useState(initialDirection);
  const [senderName, setSenderName] = useState("");
  const [senderEmail, setSenderEmail] = useState("");
  const [bodyText, setBodyText] = useState("");

  async function handleSubmit(event) {
    event.preventDefault();
    if (!bodyText.trim()) return;
    if (includeSubject && !subject.trim()) return;

    await onSubmit?.({
      subject: subject.trim(),
      direction,
      from: {
        name: senderName.trim(),
        email: senderEmail.trim(),
      },
      bodyText: bodyText.trim(),
    });

    setSubject("");
    setBodyText("");
    setSenderName("");
    setSenderEmail("");
    setDirection(initialDirection);
  }

  return (
    <form onSubmit={handleSubmit} className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
      {title ? <h4 className="text-sm font-semibold text-slate-900">{title}</h4> : null}

      <div className="mt-3 grid gap-3 md:grid-cols-3">
        <label className="space-y-1 text-sm text-slate-700">
          <span>Richting</span>
          <select
            value={direction}
            onChange={(event) => setDirection(event.target.value)}
            className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm"
            disabled={disabled}
          >
            {DEFAULT_DIRECTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </label>

        <label className="space-y-1 text-sm text-slate-700">
          <span>Naam afzender</span>
          <input
            type="text"
            value={senderName}
            onChange={(event) => setSenderName(event.target.value)}
            className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm"
            placeholder="Naam"
            disabled={disabled}
          />
        </label>

        <label className="space-y-1 text-sm text-slate-700">
          <span>E-mail afzender</span>
          <input
            type="email"
            value={senderEmail}
            onChange={(event) => setSenderEmail(event.target.value)}
            className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm"
            placeholder="naam@organisatie.nl"
            disabled={disabled}
          />
        </label>
      </div>

      {includeSubject ? (
        <label className="mt-3 block space-y-1 text-sm text-slate-700">
          <span>Onderwerp</span>
          <input
            type="text"
            value={subject}
            onChange={(event) => setSubject(event.target.value)}
            className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm"
            placeholder={subjectPlaceholder}
            disabled={disabled}
          />
        </label>
      ) : null}

      <label className="mt-3 block space-y-1 text-sm text-slate-700">
        <span>Bericht</span>
        <textarea
          value={bodyText}
          onChange={(event) => setBodyText(event.target.value)}
          rows={5}
          className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm"
          placeholder="Leg het bericht vast"
          disabled={disabled}
        />
      </label>

      <div className="mt-3 flex justify-end">
        <button
          type="submit"
          disabled={disabled || !bodyText.trim() || (includeSubject && !subject.trim())}
          className="rounded-lg bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:bg-slate-800 disabled:cursor-not-allowed disabled:opacity-60"
        >
          {submitLabel}
        </button>
      </div>
    </form>
  );
}
